













import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Employee, employeeApis } from '../api';
import SearchTransfer from './SearchTransfer.vue';
import moment from 'moment';

@Component({ components: { SearchTransfer } })
export default class EmployeeTransfer extends Vue {
  @Prop({ required: true }) selected!: Array<any>;
  @Prop({ required: true }) moveIn!: (item: Employee) => Promise<void>;
  @Prop({ required: true }) moveOut!: (item: Employee) => Promise<void>;

  employees: Array<Employee> = [];

  async mounted() {
    await this.searchEmployee('');
  }

  searchEmployee(name: string) {
    return employeeApis.search({ name }).then(employees => (this.employees = employees));
  }

  employeeTitle(e: Employee): string {
    let result = e.display_name;
    if (e.position) {
      result += ` - ${e.position}`;
    }
    // @ts-ignore
    if (e.expire_time) {
      // @ts-ignore
      result += ` - ${moment(e.expire_time).format('YYYY-MM-DD')}`;
    }
    return result;
  }

  employeeTooltip(e: Employee): string {
    let result = `${e.username} - ${e.display_name}`;
    if (e.position) {
      result += ` - ${e.position}`;
    }
    return result;
  }
}
